<template>
	<div class="float-btn" v-if="visible">
		<router-link v-if="selectedAccount" class="nav-link" :to="{ name: 'Support', params: { user_uid: selectedAccount } }">
			<svgicon name="support" :fill="true"></svgicon>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'float-support',
	data() {
		return {
			visible: true
		}
	},
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		}
	},
	methods: {
		matchRoute() {
  			if (this.$router.currentRoute.name=='Support'||this.$router.currentRoute.name=='Ticket')
				return false
			return true
		}
	},
	mounted() {
		this.visible = this.matchRoute()
	},
	watch: {
		$route (to, from) {
			this.visible = this.matchRoute()
		}
	}

}
</script>

<style>
	.float-btn {
		width: 60px;
		height: 60px;
		border-radius: 100px;
		background-color: #00a2ac;
		border: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		bottom: 80px;
		right: 80px;
		z-index: 200;
		cursor: pointer;
		box-shadow: 0 3px 5px -1px rgba(0, 162, 172, 0.2), 0 6px 10px 0 rgba(0, 162, 172, 0.14), 0 1px 18px 0 rgba(0, 162, 172, 0.12);
	}
	.float-btn svg {
		width: 25px;
		height: 25px;
		fill: white;
		stroke: white;
	}

</style>


// WEBPACK FOOTER //
// src/components/navigation/FloatSupport.vue